<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-10 09:30:39
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-05-22 11:48:26
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/register/index.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="container registerBox">
    <!-- -->
    <div class="tips" v-if="!isEdit">{{$t('lang.t39')}} <span class="login" @click="goLogin">{{$t('lang.t40')}}</span></div>

    <div class="formBox">
      <div class="formItem flex">
        <div>
          <div class="formName">{{$t('lang.t41')}} </div>
          <div class="formDesc">{{$t('lang.t42')}}</div>
        </div>
        <div class="upLoadAvatar">
          <van-uploader :after-read='upLoadFile'>
            <img :src="form.avatar" alt="" class="avatar">
          </van-uploader>
        </div>
      </div>
      <div class="formItem formNameItem">
        <div class="formName">{{$t('lang.t43')}} <span class="isRequired">*</span></div>
        <div class="name" v-if="!form.isRealName">
          <div class="formValue rightLine">
            <van-field class="custom-font" type="textarea" v-model="form.lastName" :disabled='form.isRealName' :placeholder="$t('lang.t44')" />
          </div>
          <div class="formValue rightInput">
            <van-field class="custom-font" type="textarea" v-model="form.firstName" :disabled='form.isRealName' :placeholder="$t('lang.t45')" />
          </div>
        </div>
        <div class="name" v-else>
          <div class="formValue">
            <van-field class="custom-font" v-model="form.name" :disabled='form.isRealName' :placeholder="$t('lang.t45')" />
          </div>
        </div>
      </div>

      <div class="formItem">
        <div class="formName">{{$t('lang.t46')}} <span class="isRequired">*</span></div>
        <div class="formValue">
          <van-field class="custom-font" v-model="form.company" :placeholder="$t('lang.t47')" />
        </div>
      </div>

      <div class="formItem">
        <div class="formName">{{$t('lang.t48')}}</div>
        <div class="formValue">
          <van-field class="custom-font" v-model="form.position" :placeholder="$t('lang.t49')" />
        </div>
      </div>
      <div class="formItem">
        <div class="formName">{{$t('lang.t50')}} <span class="isRequired">*</span></div>
        <div class="formValue">
          <van-field class="custom-font" v-model="form.email" :placeholder="$t('lang.t51')" />
        </div>
      </div>

      <div class="formItem formPhone">
        <div class="formLabel">{{$t('lang.t52')}}</div>
        <div class="formValue">
          <div class="areaCode" :style="{ color: form.isPhoneAccount ? '#c8c9cc': '#333'}" @click="showPhoneAreaFunc('phoneCountry')">{{form.phoneCountryCode}}</div>
          <div class="input">
            <van-field class="custom-font" v-model="form.phone" :disabled='form.isPhoneAccount' :placeholder="$t('lang.t53')" type="number" />
          </div>
          <div class="isCheck" v-if="form.isPhoneAccount">已验证</div>
        </div>
      </div>
    </div>

    <div class="line"></div>
    <div class="formBox">
      <div class="formItem">
        <div class="formName">{{$t('lang.t54')}} </div>
        <div class="formPicker" @click="openCountryPop">
          <div class="placeHolder" v-if="form.country == ''">{{$t('lang.t55')}}</div>
          <div class="word" v-else>{{form.country}}</div>
          <i class="iconfont icon">{{`\ue736`}}</i>
        </div>
      </div>
      <div class="formItem" v-if="form.country  == '中国大陆'">
        <div class="formName">{{$t('lang.t56')}} </div>
        <div class="formPicker" @click="showArea = true">
          <div class="placeHolder" v-if="form.location == ''">{{$t('lang.t57')}}</div>
          <div class="word" v-else>{{form.location}}</div>
        </div>
      </div>
      <div class="formItem">
        <div class="formName">{{$t('lang.t58')}} </div>
        <div class="formValue">
          <van-field class="custom-font" v-model="form.street" :placeholder="$t('lang.t59')" />
        </div>
      </div>
    </div>
    <div class="fixedButton">
      <div class="check" v-if="!isEdit">
        <van-checkbox v-model="radio" checked-color="#00c4c9">{{$t('lang.t60')}} <span @click.stop='goFW' class="userFile">{{$t('lang.t61')}}</span> <span @click.stop='goYS' class="userFile">{{$t('lang.t62')}}</span></van-checkbox>
      </div>
      <div class="btn" @click="save">{{!isEdit ? $t('lang.t63') : $t('lang.t78')}} </div>
    </div>

    <van-popup v-model="areaCodePicker" round position="bottom">
      <van-picker show-toolbar :confirm-button-text="$t('lang.t22')" :cancel-button-text="$t('lang.t21')" :columns="areaCodeColumns" @cancel="areaCodePicker = false" @confirm="confirmChooseAreaCode" />
    </van-popup>

    <van-popup v-model="areaPicker" round position="bottom">
      <van-picker show-toolbar :confirm-button-text="$t('lang.t22')" :cancel-button-text="$t('lang.t21')" :columns="areaColumns" @cancel="areaPicker = false" @confirm="confirmChooseArea" />
    </van-popup>

    <van-popup v-model="showArea" round position="bottom">
      <van-cascader v-model="form.location" :title="$t('lang.t57')" :field-names="fieldNames" :options="options" @close="showArea = false" @change="onChange" @finish="onFinish" />
    </van-popup>
    <van-overlay :show="showPhoneReg">
      <div class="centerDialog">
        <div class="title">{{$t('lang.t72')}}</div>
        <!-- <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/closeIcon.png" class="closeIcon" alt=""> -->
        <div class="dialogForm">
          <div class="formItem">
            <div class="formLabel">{{$t('lang.t73')}}</div>
            <div class="formValue">
              <div class="areaCode">{{form.phoneCountryCode}}</div>
              <div class="input">
                <van-field class="custom-font" v-model="form.phone" disabled :placeholder="$t('lang.t73')" type="number" />
              </div>
            </div>
          </div>

          <div class="formItem">
            <div class="formLabel">{{$t('lang.t74')}}</div>
            <div class="formValue">
              <div class="input1">
                <van-field class="custom-font" v-model="form.yzm" :placeholder="$t('lang.t75')" type="number" />
              </div>
              <div class="yzm" v-if="!isYzm" @click="getYzm">{{$t('lang.t76')}}</div>
              <div class="yzm" v-else @click="getYzm">{{second}}s</div>
            </div>
          </div>
        </div>
        <div class="jump" @click="jumpPhoneReg">{{$t('lang.t77')}}</div>
        <div class="btn" @click="submitPhoneReg">{{$t('lang.t78')}}</div>
      </div>
    </van-overlay>
    <countryPop ref="countryPop" :language="language" @valueChange="valueChange" @handleConfirm="confirmChooseArea" :countryList="allAreaCode"></countryPop>
    <van-overlay :show="loading">
      <van-loading type="spinner" color="#1989fa" style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);" />
    </van-overlay>

  </div>
</template>

<script>
import { getCountryCode, emailRegister, getProvince, getCity, getAreaByCity, checkPhone, sendYzm, checkPhoneReg, wemeetUpdate, getUserInfo, getUserLanguages, queryMyHomePage, getUserBaseInfo } from '@/api/interNational'
import { upLoadFile } from '@/api/customPageApi'
import { GetQueryString } from '@/utils/utils'
import countryPop from '../../components/countryPop.vue'
export default {
  name: 'index',

  data() {
    return {
      form: {
        content: '',
        countryCode: '',
        avatar: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/new-default-avatar.png',
        country: '',
        area: '',
        areaCode: '',
        city: '',
        cityCode: '',
        company: '',
        country: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        phoneCountryCode: '+86',
        position: '',
        province: '',
        provinceCode: '',
        street: '',
        uid: '',
        location: '',
        yzm: '',
        isPhoneAccount: false,
      },
      radio: false,
      loading: false,
      areaCodePicker: false,
      provincePicker: false,
      areaCodeColumns: [],
      areaColumns: [],
      areaPicker: false,
      allAreaCode: [],
      pcaColumns: [],
      fieldNames: {
        text: 'name',
        value: 'code',
        children: 'children',
      },
      keyword:'',
      options: [],
      isSave: false,
      showArea: false,
      showPhoneReg: false,
      isYzm: false,
      second: 60,
      isjumpFlag: false,
      isEdit: false,
      language:'CN'
    }
  },
  components:{
    countryPop
  },
  mounted() {
    this.getPhoneCode()
    this.getProvinceFunc()
    this.isEdit = GetQueryString('isEdit')
    if (this.isEdit) {
      this.language = this.$route.query.language
      this.queryDetail(this.language)
    }
  },
  computed: {
    locaelLanguage() {
      return this.$i18n.locale
    },
  },

  methods: {
    queryDetail(language) {
      getUserBaseInfo({}, { language: language }).then((res) => {
        console.log(res)
        if (res.code == 12025) {
          this.isDelete = true
          return false
        }
        res.data.location = res.data.province + res.data.city + res.data.area
        this.form = res.data
      })
    },
    goLogin() {
      this.$router.replace('/mini-h5/index/emailLogin')
    },
    goFW() {
      if (this.locaelLanguage == 'CN') {
        this.$router.push('/mini-h5/index/pdfPreview?src=https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/wmt_fw_0418.pdf&pageCount=7')
      } else {
        this.$router.push('/mini-h5/index/pdfPreview?src=https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/wmt_fw_0418_en.pdf&pageCount=11')
      }
    },
    goYS() {
      if (this.locaelLanguage == 'CN') {
        this.$router.push('/mini-h5/index/pdfPreview?src=https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/wmt_ys_0418.pdf&pageCount=7')
      } else {
        this.$router.push('/mini-h5/index/pdfPreview?src=https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/WeMeet-mini/file/wmt_ys_0418_en.pdf&pageCount=11')
      }
    },
    showPhoneAreaFunc(type) {
      this.getPhoneCode()
      if (type == 'phoneCountry') {
        if (this.form.isPhoneAccount) return false
        this.areaCodePicker = true
      } else {
        this.areaPicker = true
      }
    },
    openCountryPop(){
      this.getPhoneCode()
      this.$refs.countryPop.open()
    },
    async getPhoneCode() {
      const { data } = await getCountryCode({}, { language: this.locaelLanguage,keyword:this.keyword })
      this.allAreaCode = data
      this.$set(this.areaCodeColumns, 0, this.handlePickerAreaCode(data).pickerValueArr)
      this.$set(this.areaColumns, 0, this.handlePickerAreaCode(data).countryArr)
      // this.areaCodeColumns[0] = this.handlePickerAreaCode(data).pickerValueArr
      // this.areaColumns[0] = this.handlePickerAreaCode(data).countryArr
    },
    valueChange(e){
				this.keyword = e
				this.getPhoneCode()
			},
      countryConfirm(obj){

      },
    getYzm() {
      let params = {
        phone: this.form.phone,
        phoneCountryCode: this.form.phoneCountryCode,
        type: 'CHECK',
        language: this.$i18n.locale,
      }
      sendYzm({}, params)
        .then((res) => {
          this.isYzm = true
          var yzmInterval = setInterval(() => {
            this.second--
            if (this.second <= 0) {
              clearInterval(yzmInterval)
              this.second = 60
              this.isYzm = false
            }
          }, 1000)
        })
        .catch((err) => {})
    },
    submitPhoneReg() {
      if (this.$isEmpty(this.form.yzm)) {
        this.$toast.fail('验证码不能为空')
        return false
      }
      let params = {
        code: this.form.yzm,
        phone: this.form.phone,
        phoneCountryCode: this.form.phoneCountryCode,
      }
      checkPhoneReg({}, params)
        .then((res) => {
          this.isjumpFlag = true
          this.showPhoneReg = false
          console.log(res, '====>>>>>')
          this.form.uid = res.data.uid
          this.save()
        })
        .catch((err) => {
          if (err.code == 2002) {
            this.$toast(this.$t('lang.t18'))
          }
        })
    },
    jumpPhoneReg() {
      this.isjumpFlag = true
      this.showPhoneReg = false
      this.save()
    },

    async getProvinceFunc() {
      const { data } = await getProvince()
      console.log(data)
      data.forEach((v) => {
        v.children = []
      })
      this.options = data
      console.log(this.options)
    },
    // 省市区选择
    onChange(e) {
      console.log(e)
      let { value, tabIndex, selectedOptions } = e
      if (tabIndex == 0) {
        this.getCityFunc(value, tabIndex, selectedOptions)
      }
      if (tabIndex == 1) {
        this.getAreaFunc(value, tabIndex, selectedOptions)
      }
    },

    getCityFunc(code, index, selectedOptions) {
      getCity({}, { code }).then((res) => {
        selectedOptions[0].children = this.handleData(res.data, false)
      })
    },

    getAreaFunc(code, index, selectedOptions) {
      getAreaByCity({}, { code }).then((res) => {
        selectedOptions[selectedOptions.length - 1].children = this.handleData(res.data, true)
      })
    },

    handleData(data, notChild) {
      data.forEach((v) => {
        if (!notChild) {
          v.children = []
        }
        v.value = v.code
        v.text = v.name
      })
      return data
    },
    onFinish({ selectedOptions }) {
      this.showArea = false
      console.log(selectedOptions)
      this.form.location = selectedOptions.map((option) => option.name).join('/')
      this.form.province = selectedOptions[0].name
      this.form.provinceCode = selectedOptions[0].code
      this.form.city = selectedOptions[1].name
      this.form.cityCode = selectedOptions[1].code
      this.form.area = selectedOptions[2].name
      this.form.areaCode = selectedOptions[2].code
    },

    handlePickerAreaCode(arr) {
      let pickerValueArr = {
        values: [],
        defaultIndex: 0,
      }
      let countryArr = {
        values: [],
        defaultIndex: 0,
      }
      arr.forEach((v) => {
        let value = v.country + v.countryPhoneCode
        pickerValueArr.values.push(value)
        countryArr.values.push(v.country)
      })
      return { pickerValueArr, countryArr }
    },
    confirmChooseAreaCode(e, index) {
      this.form.phoneCountryCode = this.allAreaCode[index].countryPhoneCode
      this.areaCodePicker = false
    },

    confirmChooseArea(obj) {
      this.form.country = obj.country
      this.form.countryCode = obj.countryCode
      // this.areaPicker = false
    },
    async upLoadFile(e) {
      this.loading = true
      var headerClientInfo = { language: 'CN', eventKey: 'WeMeet', appKey: 'WX_MINI_WEMEET' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        'content-type': 'multipart/form-data',
      }
      let formData = new FormData()
      formData.append('file', e.file)
      const { data } = await upLoadFile(headers, formData)
      this.form.avatar = data

      this.loading = false
    },
    isEmpty(_string) {
      return _string == '' || _string == null || _string == undefined
    },
    save() {
      if (this.isSave) return false
      console.log(this.form)

      if (this.isEmpty(this.form.lastName) && !this.form.isRealName) {
        this.$toast(this.$t('lang.t194'))
        return false
      }
      if (this.isEmpty(this.form.firstName) && !this.form.isRealName) {
        this.$toast(this.$t('lang.t195'))
        return false
      }
      if (this.isEmpty(this.form.company)) {
        this.$toast(this.$t('lang.t197'))
        return false
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (this.isEmpty(this.form.email)) {
        this.$toast(this.$t('lang.t196'))
        return false
      }
      if (!emailRegex.test(this.form.email)) {
        this.$toast(this.$t('lang.t198'))
        return false
      }
      if (!this.radio && !this.isEdit) {
        this.$toast(this.$t('lang.t284'))
        return false
      }

      // 判断是否填写手机号，如果填写了手机号，发送验证码验证手机号
      if (!this.isjumpFlag && !this.isEdit) {
        if (!this.isEmpty(this.form.phone)) {
          checkPhone({}, { phone: this.form.phone })
            .then((res) => {
              console.log(res)
              this.$dialog
                .alert({
                  title: this.$t('lang.t82'),
                  message: this.$t('lang.t83'),
                  confirmButtonColor: '#00c4c9',
                  confirmButtonText: this.$t('lang.t84'),
                })
                .then(() => {
                  // on close
                  this.$router.push('/mini-h5/index/userLogin')
                })
            })
            .catch((err) => {
              this.showPhoneReg = true
            })
          return false
        }
      }
      // let code = this.form.countryCode
      // this.form.countryCode = this.allAreaCode.filter((v) => v.countryPhoneCode == code)[0].countryCode
      this.isSave = true
      if (this.isEdit) {
        wemeetUpdate({}, this.form)
          .then((res) => {
            this.isSave = true
            this.$toast('保存成功')
            this.$eventBus.$emit('infoChange')
            history.go(-1)
          })
          .catch((err) => {
            this.isSave = false
            if (err.code == 12029) {
              this.$dialog
                .alert({
                  title: this.$t('lang.t85'),
                  message: this.$t('lang.t86'),
                  confirmButtonColor: '#00c4c9',
                  confirmButtonText: this.$t('lang.t87'),
                })
                .then(() => {
                  // on close
                  this.$router.push('/mini-h5/index/emailLogin')
                })
              return false
            }
          })
      } else {
        var replaceUrl = localStorage.getItem('loginRedircet')
        this.form.jumpPath = replaceUrl
        this.form.language = this.$i18n.locale
        emailRegister({}, this.form)
          .then((res) => {
            this.isSave = true
            this.$dialog
              .alert({
                title: this.$t('lang.t88'),
                message: this.$t('lang.t89'),
                confirmButtonColor: '#00c4c9',
                confirmButtonText: this.$t('lang.t90'),
              })
              .then(() => {
                // on close
                this.$router.replace(replaceUrl)
                // this.$router.push('/mini-h5/index/home')
              })
          })
          .catch((err) => {
            if (err.code == 12029) {
              this.$dialog
                .alert({
                  title: this.$t('lang.t85'),
                  message: this.$t('lang.t86'),
                  confirmButtonColor: '#00c4c9',
                  confirmButtonText: this.$t('lang.t87'),
                })
                .then(() => {
                  // on close
                  this.$router.push('/mini-h5/index/emailLogin')
                })
              return false
            }
            this.isSave = false
          })
      }
    },
  },
}
</script>

<style lang='less'>
.registerBox {
  padding-bottom: 100px;
  .van-checkbox {
    justify-content: flex-start;
    .van-checkbox__icon{
      margin-right: 10px;
    }
  }
  .van-cell {
    padding: 0;
    height: 40px;
    background: transparent;
    .van-field__body {
      height: 100%;
    }
    .van-field__control {
      height: 100% !important;
      padding: 14px 0;
    }
    .van-field__word-limit {
      position: relative;
      top: -30px;
      right: 30px;
      font-size: 14px;
      color: #9e9e9e;
    }
  }
  .van-tabs__line {
    background-color: #00c4c9;
  }
  .van-cascader__option--selected {
    color: #00c4c9;
  }
  .van-checkbox__label {
    display: flex;
    flex-wrap: wrap;
    width: 300px;
  }
}
</style>
<style lang="less" scoped>
.registerBox {
  min-height: 100vh;
  background: #fff;
}
.centerDialog {
  width: 300px;
  min-height: 350px;
  background: #ffffff;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2003;
  padding: 20px 18px;
  box-sizing: border-box;
  .title {
    text-align: center;
    font-size: 16px;
    color: #262626;
  }
  .closeIcon {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 20px;
    right: 18px;
  }
  .jump {
    color: #9e9e9e;
    font-size: 15px;
    margin-top: 10px;
    text-align: center;
    width: 100%;
  }
  .btn {
    width: 264px;
    height: 44px;
    background: #00c4c9;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 15px;
    margin-top: 10px;
  }
}
.check {
  font-size: 13px;
  color: #9e9e9e;
  margin-bottom: 10px;
  .userFile {
    color: #00c4c9;
  }
}
.fixedButton {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px 15px 20px 15px;
  box-sizing: border-box;
  background-color: #fff;
  .btn {
    width: 100%;
    height: 44px;
    background: #00c4c9;
    border-radius: 10px;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 17px;
  }
}
.tips {
  width: 100%;
  min-height: 27px;
  background: rgba(255, 156, 0, 0.1);
  padding: 4px 12px;
  box-sizing: border-box;
  font-size: 13px;
  color: #ff9c00;
  .login {
    color: #00c4c9;
  }
}
.line {
  height: 11px;
  width: 100%;
  background: #f5f5f5;
}
.formBox {
  padding: 0 15px;
  box-sizing: border-box;

  .formItem {
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #d8d8d8;
    padding-top: 12px;
    &.flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .formName {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 13px;
      color: #262626;
      .isRequired {
        color: #f52f3e;
      }
    }
    .formPicker {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 70%;
      .placeHolder {
        color: #c8c9cc;
        font-size: 16px;
      }
      .word {
        color: #262626;
        font-size: 16px;
      }
      .icon {
        font-size: 20px;
        color: #d8d8d8;
      }
    }
    .areaCode {
      width: 55px;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #333;
      position: relative;
      margin-right: 10px;
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        width: 1px;
        height: 18px;
        background: #e8e8ea;
      }
    }
    .name {
      display: flex;
      align-items: center;
      .rightLine {
        position: relative;
        margin-right: 10px;
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          width: 1px;
          height: 18px;
          background: #e8e8ea;
        }
      }
      .rightInput {
        flex: 1;
        margin-left: 67px;
      }
    }
    .upLoadAvatar {
      .avatar {
        width: 44px;
        height: 44px;
        border-radius: 50%;
      }
    }
    .formDesc {
      font-size: 11px;
      color: #ff9c00;
    }
    .formValue {
      display: flex;
      align-items: center;
      height: calc(100% - 40px);
      margin-top: 10px;
      position: relative;
      .isCheck {
        position: absolute;
        top: -5px;
        right: 10px;
        color: #c8c9cc;
        font-size: 14px;
      }
      .splitIcon {
        font-size: 40px;
      }
      .timeBox {
        width: 49%;
        font-size: 16px;
        color: #262626;
        &.startTime {
          text-align: left;
        }
        &.endTime {
          text-align: right;
        }
      }
    }
    .formContent {
      width: 100%;
      height: 270px;
      background: #f5f5f5;
      border-radius: 10px;
      margin-top: 12px;
    }
  }
  .formNameItem {
    min-height: 80px;
  }
  .formPhone {
    border-bottom: 0;
    .input{ 
      width: calc(100% - 55px);
    }
  }
}

.dialogForm {
  margin-top: 25px;
  .formItem {
    border-bottom: 1px solid #eee;
    margin-bottom: 40px;
    .formLabel {
      font-size: 15px;
      color: #262626;
      font-weight: 500;
    }

    .formValue {
      width: 100%;
      display: flex;
      height: 50px;
      .input {
        width: calc(100% - 55px);
        height: 100%;
        display: flex;
        align-items: center;
        line-height: 1;
        margin-left: 18px;
        font-size: 15px;
      }
      .input1 {
        width: calc(100% - 80px);
        height: 100%;
        display: flex;
        align-items: center;
        line-height: 1;
      }
      .yzm {
        width: 80px;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #00c4c9;
        position: relative;
        justify-content: center;
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          width: 1px;
          height: 18px;
          background: #e8e8ea;
        }
      }
      .areaCode {
        width: 55px;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 15px;
        color: #333;
        position: relative;
        margin-left: 12px;
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          width: 1px;
          height: 18px;
          background: #e8e8ea;
        }
      }
    }
  }
}
</style>

<style scoped>
.custom-font {
  font-size: 16px;
}
</style>